const translations = {
  "en": {
    "Explore Now": "Explore Now",
    "Follow stocks or crypto to get real-time TA signals and Alpha insights.": "Follow stocks or crypto to get real-time TA signals and Alpha insights.",
    "Log in": "Log in",
    "Log in to view your watchlist.": "Log in to view your watchlist.",
    "No active signals": "No active signals",
    "Your Watchlist is Empty": "Your Watchlist is Empty"
  },
  "zh-tw": {
    "Explore Now": "立即探索",
    "Follow stocks or crypto to get real-time TA signals and Alpha insights.": "追蹤股票或加密貨幣以獲得即時技術分析訊號與 Alpha 洞察。",
    "Log in": "登入",
    "Log in to view your watchlist.": "登入以查看你的觀察清單。",
    "No active signals": "無活躍訊號",
    "Your Watchlist is Empty": "你的觀察清單是空的"
  }
};

export default translations;
